export function scrollToTop(behavior: "smooth" | "instant" | "auto" = "instant") {
    window.scrollTo({ top: 0, left: 0, behavior: behavior as any });
}
